// Tab pills for the product specs widget.
//
// MARKUP CONTRACT (see Son_Product_Specs)
//   <div data-son-specs-tabs>
//     <div role="tablist"> <button role="tab" aria-controls="{panel-id}">…
//     <section role="tabpanel" id="{panel-id}" [hidden]>…

function bindSpecsTabs(root) {
    if (root.dataset.sonSpecsTabsReady) {
        return;
    }
    root.dataset.sonSpecsTabsReady = 'true';

    root.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) {
            return;
        }

        root.querySelectorAll('[role="tab"]').forEach((other) => {
            const active = other === tab;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        root.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
            panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
    });
}

function initSpecsTabs(root = document) {
    root.querySelectorAll('[data-son-specs-tabs]').forEach(bindSpecsTabs);
}

document.addEventListener('DOMContentLoaded', () => initSpecsTabs());

// re-bind after Elementor editor re-renders an element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            initSpecsTabs($element[0] || document);
        });
    }
});
